// LiveStreamFloatingAnimation.js
'use strict';
import { connect } from 'react-redux';

import LiveStreamFloatingAnimation from '../component/LiveStreamFloatingAnimation.jsx';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import getListData from '../selector/getListData.js';
import { livestreamNoticeType } from '../resource/liveStreamConstants.js';

const mapStateToProps = (state, { streamId }) => {
  const noticeType = livestreamNoticeType.GIFT_NOTICE;
  const giftNoticeIds =
    getListData(state, ['liveStream', streamId, noticeType], 'itemIds') || [];
  const giftNoticeId = giftNoticeIds[0];
  const giftNoticeSelectPath = [streamId, noticeType, giftNoticeId];

  const floatingImageUrl = getLiveStreamData(
    state,
    giftNoticeSelectPath,
    'floatingImageUrl'
  );
  const shouldTriggerFloatingAnimation = getLiveStreamData(
    state,
    giftNoticeSelectPath,
    'shouldTriggerFloatingAnimation'
  );

  return {
    shouldTriggerFloatingAnimation,
    iconUrl: floatingImageUrl,
  };
};

export default connect(mapStateToProps)(LiveStreamFloatingAnimation);
